import { render } from "./SingleviewCourse.vue?vue&type=template&id=0c9a9550&scoped=true"
import script from "./SingleviewCourse.vue?vue&type=script&lang=js"
export * from "./SingleviewCourse.vue?vue&type=script&lang=js"

import "./SingleviewCourse.vue?vue&type=style&index=0&id=0c9a9550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9a9550"]])

export default __exports__